import { useLiveStats } from "../../context/LiveStats";
import { LiveDot, LiveNumber } from "../LiveNumber";

const TOTALS = [["plays", "Reproducciones"], ["downloads", "Descargas totales"], ["members", "Miembros"], ["mix_downloads", "Descargas de mixes"], ["tool_downloads", "Descargas de herramientas"], ["fx_hits", "Usos de efectos"]];

const Table = ({ title, rows, cols, testid }) => (
  <div data-testid={testid} className="border border-white/10 bg-[#0A1424]">
    <p className="font-display text-2xl px-4 pt-4 pb-2">{title}</p>
    {rows.length === 0 ? <p className="px-4 pb-4 font-mono text-xs text-[#A8B3C4]">Sin elementos.</p> : (
      <div className="overflow-x-auto">
        <table className="w-full font-mono text-xs">
          <thead><tr className="text-[#A8B3C4] uppercase tracking-widest text-left">
            <th className="px-4 py-2 font-normal">Nombre</th>
            {cols.map(([, l]) => <th key={l} className="px-4 py-2 font-normal text-right">{l}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`${testid}-row-${r.id}`} className="border-t border-white/5">
                <td className="px-4 py-2.5 max-w-[180px] truncate">{r.name}</td>
                {cols.map(([k]) => <td key={k} className="px-4 py-2.5 text-right text-white"><LiveNumber value={r[k]} /></td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export const StatsPanel = ({ data }) => {
  const { counts } = useLiveStats();
  const merge = (list, src, nameKey) => (list || []).map((x) => ({ id: x.id, name: x[nameKey], ...x, ...(src[x.id] || {}) }));
  const mixes = merge(data.mixes, counts.mixes, "title").sort((a, b) => (b.plays ?? 0) - (a.plays ?? 0));
  const tools = merge(data.tools, counts.tools, "title");
  const fx = merge(data.fx, counts.fx, "name");
  return (
    <div className="space-y-6" data-testid="admin-stats-panel">
      <LiveDot label="Actualizado cada 5 segundos" testid="admin-stats-live" />
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3">
        {TOTALS.map(([k, l]) => (
          <div key={k} className="border border-white/10 bg-[#0A1424] p-4" data-testid={`admin-total-${k}`}>
            <p className="font-heavy text-3xl text-white"><LiveNumber value={counts.totals[k]} /></p>
            <p className="font-mono text-[11px] uppercase tracking-widest text-[#A8B3C4] mt-1">{l}</p>
          </div>
        ))}
      </div>
      <Table title="Mixes" testid="admin-stats-mixes" rows={mixes} cols={[["plays", "Escuchas"], ["downloads", "Descargas"], ["likes", "Me gusta"]]} />
      <div className="grid lg:grid-cols-2 gap-6">
        <Table title="Herramientas" testid="admin-stats-tools" rows={tools} cols={[["downloads", "Descargas"]]} />
        <Table title="Efectos" testid="admin-stats-fx" rows={fx} cols={[["hits", "Usos"]]} />
      </div>
    </div>
  );
};
